import React from 'react'

import { ConfirmModal } from 'crm-components/modal'

export default () => {
    return <ConfirmModal />
}
